export default __webpack_public_path__ + "static/media/hailoffuriousstrikes3.9d8e8f8f.png";